import * as React from "react";
import type { SVGProps } from "react";
const SvgGolfCart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 5.08a1 1 0 0 1-.27-1.97 37.9 37.9 0 0 1 16.52-.39l1.92.38a1 1 0 0 1 .78 1.18 1 1 0 0 1-1.18.79l-1.555-.317 1.705 5.967.003.01.003.014.624.416a1 1 0 0 1 .45.83v5a1 1 0 0 1-1 1h-.172a3 3 0 1 1-5.656 0H8.828a3 3 0 1 1-5.656 0H3a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1v-2H3a1 1 0 0 1 0-2h1V4.863q-.396.09-.79.187zm5 3.91a1 1 0 0 0-1-1H6V4.474a36 36 0 0 1 11.03-.108l1.343 4.699a1 1 0 0 0-.633-.045 1 1 0 0 0-.63.52l-.156.312-1.499-.75.375-.562a1 1 0 0 0-.28-1.38 1 1 0 0 0-1.38.28l-2 3a1 1 0 0 0 .28 1.38.94.94 0 0 0 .55.17 1 1 0 0 0 .83-.45l.526-.79q.089.076.194.13l1.51.755-.68 1.355h-4.15a10.5 10.5 0 0 0-2.43-.8zm-2 1h.19l.5 2H6zm-1 4h1.76a8.6 8.6 0 0 1 3.79.89 1 1 0 0 0 .45.11h5a1 1 0 0 0 .89-.54l1.5-3L20 12.53v3.46H4v-2zm12.293 4.293a1 1 0 1 1 1.414 1.414 1 1 0 0 1-1.414-1.414m-12 0a1 1 0 1 1 1.414 1.414 1 1 0 0 1-1.414-1.414"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGolfCart;
